import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

import Title from '../../Symbols/Title';
import { BaseTable } from '../../Symbols/BaseTable';
import { percentFormat } from '../../Utils/NumberFormatting';
import { RegionalParty } from '../../types';

export const Table = styled(BaseTable)`
	margin-top: 1.315rem;
	margin-bottom: 2rem;

	thead {
		background-color: transparent;
	}

	thead tr td {
		padding: 0;
	}

	tr {
		border-width: 0;
		text-align: right;
	}

	td {
		padding: 0.2rem 0.5rem;
		font-size: 0.9rem;
		font-weight: 300;
	}

	td:first-child {
		width: 50%;
		text-align: left;
	}

	tbody tr:nth-child(odd) {
		background-color: #fff;
	}

	tbody tr:nth-child(even) {
		background-color: #f2f2f2;
	}

	@media (max-width: 480px) {
		td {
			padding: 0.2rem;
			font-size: 0.8125rem;
			flex-wrap: wrap;
		}
	}
`;

export function MandatesOverview(props) {
	return (
		<Table>
			<thead>
				<tr>
					<td colSpan="3">
						<Title>Počet mandátů</Title>
					</td>
				</tr>
			</thead>
			<tbody>
				{props.parties.map(
					(party) =>
						party.mandates.count > 0 && (
							<tr key={party.id}>
								<td>{party.name}</td>
								<td>{party.mandates.count}</td>
								<td>{percentFormat(party.mandates.percent)}</td>
							</tr>
						)
				)}
			</tbody>
		</Table>
	);
}

MandatesOverview.propTypes = {
	parties: PropTypes.arrayOf(PropTypes.shape(RegionalParty))
};
